import { render, staticRenderFns } from "./GanttAdmin.vue?vue&type=template&id=3aaab33c&"
import script from "./GanttAdmin.vue?vue&type=script&lang=js&"
export * from "./GanttAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports